
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import { CourseModel } from '@descomplica/dex-models';
import { ChannelModel } from '@/models/forumAPI/ChannelModel';
import { DEFAULT_CATEGORY } from '@/helpers/category';

export default Vue.extend({
  components: { Icon },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    channels(): [ChannelModel] {
      return this.$store.getters.channelsByCourseId;
    },
    isPostgraduateCourse(): boolean {
      return this.$store.getters.isPostgraduateCourse;
    },
  },
  mounted() {
    if (this.isPostgraduateCourse) {
      this.$router.push({
        name: 'home',
        params: {
          category: this.currentCourse.descomplicaCategorySlug as string,
          currentCourse: this.currentCourse.slug as string,
        },
      });
    }
  },
  methods: {
    getChannelRoute(channel: ChannelModel): string {
      const category = this.currentCourse.descomplicaCategorySlug
        ? this.currentCourse.descomplicaCategorySlug
        : DEFAULT_CATEGORY;
      return `/${category}/${this.currentCourse.slug}/forum/canal/${channel.id}`;
    },
    discussionCount(channel: ChannelModel): number {
      return channel.discussionCount;
    },
  },
});
